export default "__VITE_ASSET__8966e2ff__"